import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer, useRef, useState } from "react";
import { Button, Card, Col, Form, FormGroup, Row } from "react-bootstrap";
import { CheckLg, DashCircle, PencilFill, PlusSquareFill, Search } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import BihamtaTable from "../../Components/BihamtaTable";
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { getCostCenterList, deleteCostCenter, addNewCostCenter, editCostCenter, getCostCenterLastCode } from "../store/api/DocumentsAPI";
const ManageCostCenters = () => {

    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const filterData = useRef({ Name: "" });
    const [current, setCurrent] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    function deleteCenter(id) {
        const onSuccess = (res) => {
            if (res.Data) {
                setList(res);
            }
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف مرکز هزینه");
            }
        }
        return () => deleteCostCenter(id, onSuccess);
    }
    function rowClick(row) {
        if (current) {
            return;
        }
        setCurrent(row);
    }
    function search(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        const onGetData =(res)=>{
            if(res.Error)
            {
                setErrorDialog(dispatch,res.Error,"جستجوی مرکز هزینه");
                return;
            }
            setList(res);
        }
        getCostCenterList(filterData.current.Name, onGetData);
    }
    function cancel() {
        setCurrent(null);
    }
    function prepare4Add() {
        if (current) {
            return;
        }
        getCostCenterLastCode((res) => {
            setCurrent({
                CenterCode: res === "PENDING" ? res : res.Code,
                CenterName: "",
                ID: 0
            });
        })
    }
    function addEdit(data) {

        const onSuccess = (res) => {
            if (res.Data) {
                setList(res);
                setCurrent(null);
            }
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت/ویرایش مرکز هزینه");
            }
        }
        if (Number(data.ID) === 0) {
            addNewCostCenter(data, onSuccess);
        }
        else if (Number(data.ID) > 0) {
            editCostCenter(data, onSuccess);
        }
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد مرکز هزینه", colName: "CenterCode", showInMobile: true },
        { colTitle: "نام مرکز هزینه", colName: "CenterName", showInMobile: true }
    ];
    const tableRowButtons = [
        {
            title: "حذف", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteCenter(item.ID)
                }))
            }
        }];
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle"><FontAwesomeIcon icon={faShoppingBasket} size="lg" />&nbsp;
                    مدیریت مرکز هزینه
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ minHeight: "40vh", textAlign: "right" }}>
                    <Row>
                        <Col md={5} className="rowBorder">
                            <FormGroup style={{ width: "60%", display: "inline-block" }}>
                                <Form.Control placeholder="نام مرکز هزینه مورد جستجو" onChange={e => filterData.current.Name = e.target.value} onKeyDown={search} />
                                <Button className="btn-input-tiny" style={{ top: "8px", left: "2px" }} onClick={search}><Search size={20} /></Button>
                            </FormGroup>
                            <PlusSquareFill size={30} color="#7c42e9" className="hoverIcon" style={{ marginRight: "4px", cursor: "pointer" }} onClick={prepare4Add} />
                            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} rowClick={rowClick} dataList={list} hasPaging={false} />
                        </Col>
                        {current &&
                            <Col md={3} className="rowBorder" style={{ marginRight: "5px" }}>
                                <form onSubmit={handleSubmit(addEdit)} >
                                    <FormGroup>
                                        <input type="hidden" defaultValue={current.ID} name="ID" ref={register({ required: true })} />
                                        <label>کد مـرکـز هـزینه</label>
                                        {current.CenterCode === "PENDING" &&
                                            <div className="form-control"><Loader type="BallTriangle" width={22} height={22} color="#bb1370" /></div>
                                        }
                                        {current.CenterCode !== "PENDING" &&
                                            <Form.Control defaultValue={current.CenterCode} name="CenterCode" ref={register({ required: true })} />
                                        }
                                        {errors?.CenterCode && <small className="errors">کد مرکز هزینه وارد نشده است</small>}
                                    </FormGroup>
                                    <FormGroup>
                                        <label>نام مـرکـز هـزینه</label>
                                        <Form.Control defaultValue={current.CenterName} name="CenterName" ref={register({ required: true })} />
                                        {errors?.CenterName && <small className="errors">نام مرکز هزینه وارد نشده است</small>}
                                    </FormGroup>
                                    <FormGroup>
                                        {Number(current.ID) === 0 && <Button variant="success" className="group-Btn" type="submit"><CheckLg />&nbsp;ثبت مرکز هزینه</Button>}
                                        {Number(current.ID) > 0 && <Button variant="success" className="group-Btn" type="submit"><PencilFill />&nbsp;ویرایش مرکز هزینه</Button>}
                                        <Button variant="danger" className="group-Btn" onClick={cancel}><DashCircle size={15} />&nbsp; انصراف</Button>
                                    </FormGroup>
                                </form>
                            </Col>
                        }
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )

}
export default ManageCostCenters;